import request from '@/utils/request';

/**
 * 添加系统表单
 * @param data
 * @returns {AxiosPromise}
 */
export function systemFormAddApi(data) {
  return request({
    url: '/admin/merchant/system/form/add',
    method: 'post',
    data: data
  });
}

/**
 * 删除系统表单
 * @param id
 * @returns {AxiosPromise}
 */
export function systemFormDeleteApi(id) {
  return request({
    url: "/admin/merchant/system/form/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 系统表单详情
 * @param id
 * @returns {AxiosPromise}
 */
export function systemFormDetailApi(id) {
  return request({
    url: "/admin/merchant/system/form/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 系统表单分页列表
 * @param params
 * @returns {AxiosPromise}
 */
export function systemFormPageApi(params) {
  return request({
    url: "/admin/merchant/system/form/page",
    method: 'get',
    params: params
  });
}

/**
 * 修改系统表单
 * @param data
 * @returns {AxiosPromise}
 */
export function systemFormUpdateApi(data) {
  return request({
    url: "/admin/merchant/system/form/update",
    method: 'post',
    data: data
  });
}